module.exports = __webpack_public_path__ + "static/media/send-disable.093df749.svg";